export default "<app-nav-bar-teams></app-nav-bar-teams>\n\n<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>"